import * as types from '../mutation-types'

const state = {
  // Lendo os produtos selecionados de string para JSON de localStorage
  main: []
}

const mutations = {
  [types.ATUALIZAR_CLONE_ATIVO] (state, clone) {
    /**
       * Atualiza O produto selecionado e salva como string em localStorage
       */
     state.main = clone;
    //  localStorage.setItem('produtoAtivo', JSON.stringify(produto));
  },
  [types.REMOVER_CLONE_ATIVO] (state) {
    /**
       * Limpa O produto selecionados
       */
     state.main = [];
    //  localStorage.removeItem('produtoAtivo');
  },

}

export default {
  state,
  mutations
}

